import { render, staticRenderFns } from "./CreateProductNotificationModal.vue?vue&type=template&id=65246770&scoped=true&"
import script from "./CreateProductNotificationModal.vue?vue&type=script&lang=js&"
export * from "./CreateProductNotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateProductNotificationModal.vue?vue&type=style&index=0&id=65246770&prod&lang=scss&"
import style1 from "./CreateProductNotificationModal.vue?vue&type=style&index=1&id=65246770&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65246770",
  null
  
)

export default component.exports